import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";

const Navbar = ({ isMobileMenuOpen, setIsMobileMenuOpen }) => {
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
  const [selectedLang, setSelectedLang] = useState("EN");

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setIsMobileMenuOpen(false); // close mobile menu after navigation
    }
  };

  const toggleLangDropdown = () => {
    setIsLangDropdownOpen((prev) => !prev);
  };

  const selectLanguage = (lang) => {
    setSelectedLang(lang);
    setIsLangDropdownOpen(false);
  };

  useEffect(() => {
  if (isMobileMenuOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }

  return () => {
    document.body.style.overflow = "";
  };
}, [isMobileMenuOpen]);


  useEffect(() => {
    const handleScroll = () => {
      if (isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
    };

    if (isMobileMenuOpen) {
      window.addEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMobileMenuOpen]);

  return (
    <div className="flex flex-col justify-center p-5 md:h-[159px] lg:px-[200px] py-4 md:py-12 items-center">
      <nav
        style={{
          background: isMobileMenuOpen
            ? undefined
            : "linear-gradient(90deg, rgba(142, 149, 155, 0.8) 1.14%, rgba(51, 58, 69, 0.8) 100%)",
        }}
        className={`text-white h-[60px] py-4 pl-6 pr-3 w-full flex justify-between items-center md:w-[650px] lg:w-[880px] relative ${
          isMobileMenuOpen
            ? ""
            : "backdrop-blur-md shadow-lg border rounded-full"
        }`}
      >
        <div className="w-[70px] md:w-[173px] flex items-center">
          <img src="/Logo.png" alt="Coaler Logo" className="w-5 h-5" />
          <img src="/COALER.png" alt="Coaler Logo" className="h-4 w-20" />
        </div>

        <div className="hidden md:block">
          <ul className="flex gap-3 items-center">
            <li className="cursor-pointer" onClick={() => scrollToSection("how-it-works")}>
              How It works
            </li>
            <li className="cursor-pointer" onClick={() => scrollToSection("why-coaler")}>
              Why Coaler
            </li>
            <li className="cursor-pointer" onClick={() => scrollToSection("contact")}>
              Contact
            </li>
          </ul>
        </div>

        <button
          className="md:hidden p-2 z-50"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <img src="/hamburgermenu.png" alt="Menu" className="w-6 h-6" />
        </button>

        <div className="hidden md:flex gap-4 items-center relative">
          {/*<div className="relative">
            <div
              className="flex items-center cursor-pointer"
              onClick={toggleLangDropdown}
            >
              <span className="text-white">{selectedLang}</span>
              <img
                src="/down_symbol.png"
                alt="downsymbol"
                className="w-6 h-6 ml-2"
              />
            </div>
            {isLangDropdownOpen && (
              <div className="absolute top-8 right-0 bg-white text-black rounded-md shadow-lg w-24 z-50">
                <div
                  className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                  onClick={() => selectLanguage("EN")}
                >
                  EN
                </div>
                <div
                  className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                  onClick={() => selectLanguage("Hindi")}
                >
                  Hindi
                </div>
              </div>
            )}
          </div>*/}

        </div>
      </nav>

      {/* Slide Down Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  exit={{ opacity: 0 }}
  transition={{ duration: 0.5, ease: "easeInOut" }}
  className="fixed inset-0 bg-black z-40 overflow-hidden"
>

            <div className="flex flex-col text-5xl items-start justify-center h-full px-6 py-8 gap-8">
              <ul className="flex flex-col gap-6 font-semibold text-white">
                <li onClick={() => scrollToSection("how-it-works")}>How It works</li>
                <li onClick={() => scrollToSection("why-coaler")}>Why Coaler</li>
                <li onClick={() => scrollToSection("contact")}>Contact</li>
              </ul>

              <div className="flex flex-col gap-4 w-full relative">
                {/*<div className="relative">
                  <div
                    className="flex items-center gap-2 cursor-pointer text-white"
                    onClick={toggleLangDropdown}
                  >
                    <span>{selectedLang}</span>
                    <img
                      src="/down_symbol.png"
                      alt="downsymbol"
                      className="w-12 h-12"
                    />
                  </div>
                  {isLangDropdownOpen && (
                    <div className="absolute top-15 left-0 bg-[#1E1E1E] text-black rounded-md shadow-lg w-32 z-50">
                      <div
                        className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                        onClick={() => selectLanguage("EN")}
                      >
                        EN
                      </div>
                      <div
                        className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                        onClick={() => selectLanguage("Hindi")}
                      >
                        Hindi
                      </div>
                    </div>
                  )}
                </div>*/}

                <button
                  onClick={() => scrollToSection("contact")}
                  className="w-fit rounded-full border-2 border-white text-white px-6 py-2"
                >
                  Sign Up
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Navbar;
